import { render } from "./VideoDiv.vue?vue&type=template&id=25a22e6c&scoped=true&ts=true"
import script from "./VideoDiv.vue?vue&type=script&lang=ts"
export * from "./VideoDiv.vue?vue&type=script&lang=ts"

import "./VideoDiv.vue?vue&type=style&index=0&id=25a22e6c&scoped=true&lang=scss"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/wanfei-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25a22e6c"]])

export default __exports__